import { useContext } from 'react';

import { BuilderStepNavigationContext } from '@features/campaigns/builder/providers/BuilderStepNavigationProvider/providerSetup.ts';

export function useBuilderStepNavigation() {
  const context = useContext(BuilderStepNavigationContext);
  if (!context) {
    throw new Error('useBuilderStepNavigation must be used within BuilderStepNavigationProvider');
  }
  return context;
}
